import { IForm, FormContructorParams, Form } from '@app/forms/form.model';
import { ILegacy } from '@app/legacy/legacy.interface';
import { Injectable } from '@angular/core';
import { LegacyService } from '@app/legacy/legacy.service';
import { Logger } from '@app/logger/logger';
import { Observable, from, of } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { WindowService } from '@app/shared/window.service';
import { AUJS_FORMS } from '@app/forms/shared/aujs-forms';

const lgSfx = '\t(form.service)';

export enum OpenFormTarget {
  SameWindow = 1,
  NewWindow = 2,
  NewTab = 3
}

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private legacy: ILegacy;
  private currentForm: Form;

  constructor(
    private router: Router,
    private legacyService: LegacyService,
    private log: Logger,
    private windowService: WindowService
  ) {
    this.legacy = this.legacyService.service;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        for (const property in AUJS_FORMS) {
          if (
            AUJS_FORMS.hasOwnProperty(property) &&
            event.url.includes(AUJS_FORMS[property].path)
          ) {
            this.currentForm = AUJS_FORMS[property];
          }
        }
      }
    });
  }

  public getFormWithParams(params: FormContructorParams): IForm {
    return new Form(params);
  }

  public openForm(form: IForm, target = OpenFormTarget.SameWindow): Observable<boolean> {
    this.log.log(`Opening form: ${form.enumId} ${lgSfx} ${target}`);

    if (form.legacy === true) {
      this.legacy.openForm(form.enumId);
    } else if (typeof form.path !== 'undefined' && form.path !== null && form.path.length > 0) {
      this.log.log(`Opening form path ${form.path}`);

      switch (target) {
        case OpenFormTarget.SameWindow: {
          this.currentForm = form;
          return from(this.router.navigate([form.path]));
        }

        case OpenFormTarget.NewTab: {
          this.openFormInNewTab(form);
          return of(true);
        }

        case OpenFormTarget.NewWindow: {
          // TODO: Need to get this NewWindow one setup and working
          return from(this.router.navigate([form.path]));
        }

        default: {
          this.log.error(
            `Unable to open requested form (${form.id}); loading in SameWindow ${lgSfx}`
          );
          return from(this.router.navigate([form.path]));
        }
      }
    } else {
      this.log.error(`Unable to open requested form (${form.id}) ${lgSfx}`);
    }
  }

  private openFormInNewTab(form: IForm): void {
    if (!this.legacy.canOpenTabs) {
      return this.openFormInNewWindow(form);
    }

    this.legacy.openTab([form.path]);
  }

  private openFormInNewWindow(form: IForm): void {
    this.windowService.openCurrentViewInNewWindow(form.path);
  }

  public getCurrentForm(): Form {
    return this.currentForm;
  }

  public setFormStatus(isDirty: boolean): void {
    if (this.currentForm) {
      this.currentForm.isDirty = isDirty;
    }
  }
}
